import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import {
  DEFAULT_LISTING_CREATION_PATH,
  getCreateListingRedirectTarget,
} from '../../../util/sellerVerification';

import css from './NoSearchResultsMaybe.module.css';

const NoSearchResultsMaybe = props => {
  const { listingsAreLoaded, totalItems, location, resetAll, showCreateListingsLink, currentUser } =
    props;
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;
  const createListingTarget = getCreateListingRedirectTarget(
    currentUser,
    DEFAULT_LISTING_CREATION_PATH
  );

  const createListingLinkMaybe = showCreateListingsLink ? (
    <NamedLink
      className={css.createListingLink}
      name={createListingTarget.name}
      to={createListingTarget.to}
    >
      <FormattedMessage id="SearchPage.createListing" />
    </NamedLink>
  ) : null;

  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <h4>
        <FormattedMessage id="SearchPage.noResults" />
      </h4>
      <div className={css.actions}>
        {hasSearchParams ? (
          <button className={css.resetAllFiltersButton} onClick={e => resetAll(e)}>
            <FormattedMessage id={'SearchPage.resetAllFilters'} />
          </button>
        ) : null}
        {createListingLinkMaybe}
      </div>
    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
